import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { ThemeProvider } from '@/components/theme-provider'
import { AuthProvider } from '@/lib/auth/auth-context'
import { TransactionProvider } from '@/lib/context/transaction-context'
import { Toaster } from '@/components/ui/sonner'
import { WelcomeGuard } from '@/components/WelcomeGuard'
import HomePage from '@/pages/HomePage'
import AuthPage from '@/pages/AuthPage'
import WelcomePage from '@/pages/WelcomePage'
import ProtectedRoute from '@/components/ProtectedRoute'

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
        <AuthProvider>
          <TransactionProvider>
            <WelcomeGuard>
              <Routes>
                <Route path="/" element={<Navigate to="/auth" replace />} />
                <Route path="/welcome" element={<WelcomePage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route
                  path="/home"
                  element={
                    <ProtectedRoute>
                      <HomePage />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </WelcomeGuard>
            <Toaster />
          </TransactionProvider>
        </AuthProvider>
      </ThemeProvider>
      <Analytics />
    </BrowserRouter>
  )
}

export default App
